export default __webpack_public_path__ + "static/IMG_0255-a809ca1f51a647b8c82d035596ab4bb7.jpeg";